module["exports"] = [
  "#####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/tr/address/postcode.js
// module id = 1632
// module chunks = 0